import { useEffect, useState } from 'react';

/**
 * Shared object-URL cache keyed by File identity. The same File reference
 * always resolves to the same blob URL for its lifetime, so re-parenting a
 * File between components (e.g. swapping front/back) doesn't tear down and
 * re-decode the underlying <img>. The WeakMap lets the URL be reclaimed when
 * the File itself is garbage-collected.
 */
const urlCache = new WeakMap<File, string>();

function getUrl(file: File): string {
  const cached = urlCache.get(file);
  if (cached) return cached;
  const url = URL.createObjectURL(file);
  urlCache.set(file, url);
  return url;
}

export function useStableObjectUrl(file: File | null | undefined): string {
  const [url, setUrl] = useState<string>(() => (file ? getUrl(file) : ''));
  useEffect(() => {
    setUrl(file ? getUrl(file) : '');
  }, [file]);
  return url;
}
